import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import Utils from '../../../utils/Utils';
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class Login360Task extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.ownParams = params;
    }

   getParams() {
        return this.ownParams;
    }

    getMethod() {
        return 'POST';
    }

    getHeaders() {
        return {
          'Content-Type': 'application/x-www-form-urlencoded'
        };
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");

      return `${http}${url}/services/user/threesixty/auth?${Utils.buildQueryParams(super.getParams())}`;
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }

}

export default Login360Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/Login360Task.js